import { useEffect, useState } from "react";

// react-modal puts this on body while any of its dialogs are mounted
const REACT_MODAL_BODY_CLASS = "ReactModal__Body--open";

// XModal is plain markup rather than react-modal, so it carries its own marker
const MODAL_ROOT_SELECTOR = "[data-modal-open]";

const readIsModalOpen = () =>
   document.body.classList.contains(REACT_MODAL_BODY_CLASS) ||
   Boolean(document.querySelector(MODAL_ROOT_SELECTOR));

// The app has two unrelated modal implementations and neither reports upwards,
// so the DOM is the only thing that knows about all of them
const useIsModalOpen = () => {
   const [isModalOpen, setIsModalOpen] = useState(readIsModalOpen);

   useEffect(() => {
      const sync = () => setIsModalOpen(readIsModalOpen());

      const observer = new MutationObserver(sync);
      observer.observe(document.body, {
         attributes: true,
         attributeFilter: ["class", "data-modal-open"],
         childList: true,
         subtree: true,
      });

      sync();

      return () => observer.disconnect();
   }, []);

   return isModalOpen;
};

export default useIsModalOpen;
